import React, { Component, createRef } from "react";
import { Navigate } from "react-router-dom";
import { apiService } from "services/api";
import AuthService from "services/auth.service";
import { Form, Button } from "react-bootstrap";
import { Formik, ErrorMessage, Field } from "formik";
import Select from "react-select";
import "./../../assets/styles/Customer.scss";
import "../../modules/global";

import * as yup from "yup";
import moment from "moment";

let currentUser = AuthService.getCurrentUser();
class AddCustomer extends Component {
  constructor(props) {
    super(props);

    this.formActions = createRef();

    this.params = new URLSearchParams(window.location.search);

    this.base_registry = {
      caring_store_id: currentUser?.caring_stores[0]?.id,
      state_id: currentUser?.caring_stores[0]?.state_id,
    };

    this.base_update = {
      email: "",
      gender: "",
      name: "",
      phone_number: "",
      booked_date: null,
      age: "",
    };

    this.state = {
      search: {
        phone_number: this.params.get("phone_number") || "",
      },
      registry: this.base_registry,
      update: this.base_update,
      formErrors: [],
      info: {},
      maxDate: moment().format("YYYY-MM-DD"),
    };
  }

  updateSchema = yup.object().shape(
    {
      name: yup.string().required().max(100).label("Name"),
      age: yup.object().required().label("Age"),
      email: yup.string().when("email", {
        is: (exists) => !!exists,
        then: yup.string().email().required().max(50).label("Email"),
        otherwise: yup.string().notRequired(),
      }),
      phone_number: yup
        .string()
        .required()
        .min(10, "Phone number is invalid")
        .max(15, "Phone number is invalid")
        .matches("^[0-9]*$", "Phone number is invalid")
        .label("Phone number"),
    },
    [["email", "email"]],
  );

  handleCreate(formData, actions) {
    this.formActions = actions;
    this.setState(
      (prevState) => {
        const caringStoreId = currentUser?.caring_stores[0]?.id;
        const stateId = currentUser?.caring_stores[0]?.state_id;

        return {
          info: {
            ...prevState.info,
            name: formData.name,
            email: formData.email,
            phone_number: formData.phone_number,
            gender: formData.gender.value,
            age: formData.age.value,
            booked_date: formData.booked_date,
            state_id: stateId,
            caring_store_id: caringStoreId,
          },
        };
      },
      () => {
        this.submit();
      },
    );
  }

  submit() {
    if (this.state.registry.caring_store_id) {
      this.setState({
        formErrors: "",
      });
      apiService.add_customer(this.state.info).then(
        (response) => {
          if (response && response.hasOwnProperty("errors")) {
            this.setState({
              formErrors: response.errors,
            });
          } else {
            if (this.params.get("phone_number")) {
              window.location.replace("/admin/dashboard");
            } else {
              alert("Submitted successfully");
              this.formActions.resetForm({});
            }
          }
        },
        (error) => {
          this.setState({ error, loading: false });
        },
      );
    }
  }

  render() {
    if (currentUser?.role !== "caring_store_admin") {
      return <Navigate to="/admin/dashboard" />;
    }
    const SelectField = (FieldProps) => (
      <Select
        className="select-field"
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option)
        }
      />
    );

    return (
      <div className="customer-page">
        <div className="content-container">
          <Formik
            enableReinitialize
            validationSchema={this.updateSchema}
            onSubmit={(form, actions) => this.handleCreate(form, actions)}
            initialValues={this.state.update}
          >
            {({ handleSubmit, handleChange, values }) => (
              <React.Fragment>
                <div className="info-container">
                  <h4 style={{ fontWeight: "bold" }}>
                    New Customer Information
                  </h4>
                  <div
                    className={
                      this.state.update.date_done ? "disabled-form" : ""
                    }
                  >
                    <div className="d-flex justify-content-between field-row ">
                      <Form.Group className="mb-3 field-col">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          name="name"
                          type="text"
                          value={values.name}
                          maxLength="100"
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          component="div"
                          name="name"
                          className="invalid-feedback"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3 field-col">
                        <Form.Label>Age</Form.Label>
                        <Field
                          name="age"
                          placeholder="Age*"
                          options={global.constant.ages}
                          value={values.age}
                          component={SelectField}
                        />
                        <ErrorMessage
                          component="div"
                          name="age"
                          className="invalid-feedback"
                        />
                      </Form.Group>
                    </div>

                    <div className="d-flex justify-content-between field-row">
                      <Form.Group className="mb-3 field-col">
                        <Form.Label>Email (Optional)</Form.Label>
                        <Form.Control
                          name="email"
                          type="email"
                          value={values.email}
                          maxLength="50"
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          component="div"
                          name="email"
                          className="invalid-feedback"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3 field-col">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          name="phone_number"
                          type="text"
                          value={values.phone_number}
                          maxLength="20"
                          onChange={handleChange}
                          placeholder="60123456789"
                        />
                        <ErrorMessage
                          component="div"
                          name="phone_number"
                          className="invalid-feedback"
                        />
                      </Form.Group>
                    </div>

                    <div className="d-flex justify-content-between field-row select-field">
                      <Form.Group className="mb-3 field-col field-row select-field">
                        <Form.Label>Gender (Optional)</Form.Label>
                        <Field
                          name="gender"
                          options={global.constant.genders}
                          component={SelectField}
                        />
                        <ErrorMessage
                          component="div"
                          name="gender"
                          className="invalid-feedback"
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <div className="form-container">
                    <ul className="form-errors">
                      {Object.entries(this.state.formErrors).map((key, i) => (
                        <li key={i}>
                          {key[0]}: {key[1]}
                        </li>
                      ))}
                    </ul>
                    <Form noValidate onSubmit={handleSubmit}>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          type="submit"
                          className="submit-btn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </React.Fragment>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

export { AddCustomer };
